/**
 * @export
 * @class OurStory
 */
import { get } from '../../helpers/utilities';

import { Timeline } from './timeline';

export class OurStory {
    public static id = 'our-story';


    /**
     * Creates an instance of OurStory.
     * 
     * @memberof OurStory
     */
    constructor() {
        this.timeline();
    }


    /**
     * Initiates the timeline for the page.
     *
     * @private
     * @memberof OurStory
     */
    private timeline(): void {
        const container = get('#js-our-story') as HTMLElement;
        if(container) {
            window.app.modules.site_header.disableChange = true;
            new Timeline(container);
        }
    }
}
